import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
export const LoaderContainer = styled.div `
  max-height: 3.4rem;
`;
export const CustomLoader = styled(ContentLoader) `
  height: 3.4rem;

  width: 100%;
`;
export const Text = styled.rect `
  x: calc((100% - 15rem) / 2);
  y: 0;

  width: 15rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;
export const FirstLight = styled.rect `
  x: 0;
  y: 2.8rem;

  width: calc((100% - 0.8rem) / 3);
  height: 0.6rem;

  rx: ${({ theme }) => theme.borderRadius.low};
  ry: ${({ theme }) => theme.borderRadius.low};
`;
export const SecondLight = styled.rect `
  x: calc((100% - 0.8rem) / 3 + 0.4rem);
  y: 2.8rem;

  width: calc((100% - 0.8rem) / 3);
  height: 0.6rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.low};
`;
export const ThirdLight = styled.rect `
  x: calc(2 * (100% - 0.8rem) / 3 + 0.8rem);
  y: 2.8rem;

  width: calc((100% - 0.8rem) / 3);
  height: 0.6rem;

  rx: ${({ theme }) => theme.borderRadius.low};
  ry: ${({ theme }) => theme.borderRadius.low};
`;
//# sourceMappingURL=styles.js.map